import React from 'react';
import { FaTimes } from 'react-icons/fa';
import dayjs from 'dayjs';

const UserViewModal = ({ open, onClose, user }) => {
  if (!open || !user) return null;

  const sections = [
    {
      title: 'User Information',
      fields: [
        { label: 'Username', value: user.Username },
        { label: 'Full Name', value: user.FullName },
        { label: 'Email', value: user.Email },
        { label: 'Phone', value: user.Phone || '-' },
        { label: 'Role', value: user.Role },
        { label: 'Status', value: user.IsActive ? 'Active' : 'Inactive' },
      ]
    },
    {
      title: 'System Information',
      fields: [
        { label: 'Created At', value: user.CreatedAt ? dayjs(user.CreatedAt).format('YYYY-MM-DD HH:mm') : '-' },
        { label: 'Last Login', value: user.LastLogin ? dayjs(user.LastLogin).format('YYYY-MM-DD HH:mm') : '-' },
      ]
    }
  ];

 return (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-[#E5E1DA] rounded-2xl shadow-2xl w-full max-w-2xl p-4 sm:p-6 md:p-8 relative overflow-y-auto max-h-[90vh] mx-2">
      {/* Close button */}
      <button
        className="absolute top-3 right-3 text-[#2b6777] hover:text-[#52ab98]"
        onClick={onClose}
      >
        <FaTimes size={10} className="w-3 h-3 sm:w-5 sm:h-5"  />
      </button>

      {/* Title */}
      <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-[#2b6777] mb-4 sm:mb-6 text-center">
        User Details
      </h2>

      {/* Sections */}
      <div className="space-y-4 sm:space-y-6">
        {sections.map((section, index) => (
          <div key={index} className="bg-white rounded-xl p-4 sm:p-6">
            <h3 className="text-base sm:text-lg font-bold text-[#2b6777] mb-3 sm:mb-4">
              {section.title}
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              {section.fields.map((field, fieldIndex) => (
                <div key={fieldIndex} className="flex flex-col">
                  <span className="text-xs sm:text-sm font-medium text-gray-600">
                    {field.label}
                  </span>
                  <span className="text-sm sm:text-base text-gray-900 mt-1">
                    {field.label === "Status" ? (
                      <span
                        className={`inline-block px-2 sm:px-3 py-1 rounded-full text-[10px] sm:text-xs font-bold shadow-sm ${
                          field.value === "Active"
                            ? "bg-[#52ab98] text-white"
                            : "bg-gray-300 text-gray-500"
                        }`}
                      >
                        {field.value}
                      </span>
                    ) : (
                      field.value
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Close Button Footer */}
      <div className="mt-4 sm:mt-6 flex justify-center sm:justify-end">
        <button
          className="px-3 sm:px-4 py-2 rounded bg-[#52ab98] hover:bg-[#2b6777] text-white text-sm sm:text-base font-semibold shadow transition w-full sm:w-auto"
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

};

export default UserViewModal; 